

  // 如果这是在 vue/react/js 文件中，通常需要 'function' 关键字或 const
export function formatCouponItem(item) {
    let showNumber = "-";
    let showTip = "-";    
    // 确保转换为数字，防止字符串计算错误
    const dType = Number(item.discountType);

    switch (dType) {
      case 1:
        // 立减
        showNumber = item.fixedAmount;
        showTip = "立减";
        break;

      case 2:
        // 满减
        showNumber = item.fullReduceAmount;
        showTip = `满${item.fullReduceThreshold}可用`;
        break;

      case 3:
        // 折扣 (例如 9.7 折)
        showNumber = item.discountValue;
        showTip = `满${item.discountThreshold}可用`;
        break;

      default:
        // 防御性代码
        break;
    }

    return {
      ...item,
      claimRecordId: item.claimRecordId , 
      showNumber: showNumber,
      showTip: showTip,
      couponName: item.couponName,
      expireTime: item.expireTime ? `有效期至${item.expireTime.replace(/-/g, ".")}` : "", 
      reason: item.reason,
      selected: false,
      discountAmount: item.discountAmount
    };

    
}